import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { canManageManagersGuard, canManageParametrosGuard } from './guards/menu-permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'solicitations',
    loadComponent: () => import('./pages/solicitations/solicitations.component').then(m => m.SolicitationsComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'solicitation-form',
    loadComponent: () => import('./pages/solicitation-form/solicitation-form.component').then(m => m.SolicitationFormComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'approvals',
    loadComponent: () => import('./pages/approvals/approvals.component').then(m => m.ApprovalsComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'managers',
    loadComponent: () => import('./pages/managers/managers.component').then(m => m.ManagersComponent),
    canActivate: [MsalGuard, canManageManagersGuard]
  },
  {
    path: 'solicitation-query',
    loadComponent: () => import('./pages/solicitation-query/solicitation-query.component').then(m => m.SolicitationQueryComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'parametros-solicitacao',
    loadComponent: () => import('./pages/parametros-solicitacao/parametros-solicitacao.component').then(m => m.ParametrosSolicitacaoComponent),
    canActivate: [MsalGuard, canManageParametrosGuard]
  },
  {
    path: 'estatisticas-nf',
    loadComponent: () => import('./pages/estatisticas-nf/estatisticas-nf.component').then(m => m.EstatisticasNfComponent),
    canActivate: [MsalGuard]
  }
];
